import { type MessageInstance } from "antd/es/message/interface";

import { privateAPI } from "../../../_config/constants";
import { errorHandler } from "../../_utils";
import { type NotificationFormType, store } from "..";
import {
  addNotification,
  removeNotification,
  setNotificationLoading,
  setNotifications,
  updateNotificationAction,
} from "../slices/notificationSlice";

export const getNotifications = async (notify: MessageInstance) => {
  try {
    store.dispatch(setNotificationLoading(true));
    const response = await privateAPI.get("/get-notification");
    if (response) {
      store.dispatch(setNotificationLoading(false));
      store.dispatch(setNotifications(response.data));
    }
    return response;
  } catch (error) {
    store.dispatch(setNotificationLoading(false));
    console.error("Get Notification Error:", error);
    errorHandler(error, notify);
  }
};

export const createNotification = async (
  notify: MessageInstance,
  payload: NotificationFormType,
) => {
  try {
    store.dispatch(setNotificationLoading(true));

    // Simulate API call with local state management
    const newNotification = {
      ...payload,
      id: Date.now().toString(), // Generate simple ID
    };

    // Add to local state
    store.dispatch(addNotification(newNotification));
    notify.success("Notification created successfully!");

    return newNotification;
  } catch (error) {
    console.error("Create Notification Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setNotificationLoading(false));
  }
};

export const updateNotification = async (
  notify: MessageInstance,
  payload: NotificationFormType,
) => {
  try {
    if (!payload.id) return;
    store.dispatch(setNotificationLoading(true));

    // Simulate API call with local state management
    store.dispatch(updateNotificationAction(payload));
    notify.success("Notification updated successfully!");

    return payload;
  } catch (error) {
    console.error("Update Notification Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setNotificationLoading(false));
  }
};

export const deleteNotification = async (
  notify: MessageInstance,
  id: string,
  getData = false,
) => {
  try {
    store.dispatch(setNotificationLoading(true));

    // Simulate API call with local state management
    store.dispatch(removeNotification(id));
    getData && (await getNotifications(notify));
    notify.success("Notification deleted successfully!");

    return { success: true };
  } catch (error) {
    console.error("Delete Notification Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setNotificationLoading(false));
  }
};
